// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"775":"459fe432","2844":"11ee7935","4226":"d004cf89","5105":"d004cf89","5289":"291cbf28","8857":"d004cf89"}[chunkId] + ".chunk.css";
};